"use strict";

var _regeneratorRuntime = require("/home/runner/work/ami/ami/jaenjs/templates/jaen-template-shopify/node_modules/@babel/runtime/regenerator/index.js");

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icons = require("@chakra-ui/icons");

var _layout = require("@chakra-ui/layout");

var _react = require("@chakra-ui/react");

var _FaFile = require("@react-icons/all-files/fa/FaFile");

var _FaFilePdf = require("@react-icons/all-files/fa/FaFilePdf");

var _FaFolder = require("@react-icons/all-files/fa/FaFolder");

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _react2 = _interopRequireWildcard(require("react"));

var _reactDropzone = require("react-dropzone");

var _mimeTypes = require("../../../common/mimeTypes");

var _url = require("../../../common/url");

var _uuid3 = require("../../../common/uuid");

var _ContextModal = _interopRequireDefault(require("../../molecules/ContextModal"));

var _FileContextMenu = _interopRequireDefault(require("../../molecules/FileContextMenu"));

var _FileInfoBox = _interopRequireDefault(require("../../molecules/FileInfoBox"));

var _FileList = _interopRequireDefault(require("../../molecules/FileList"));

var _Toolbar = _interopRequireDefault(require("../../molecules/Toolbar"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["mode"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Finder = function Finder(_ref) {
  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'browser' : _ref$mode,
      props = _objectWithoutProperties(_ref, _excluded);

  var toast = (0, _react.useToast)();
  var folderCreateContextModal = (0, _react.useDisclosure)();
  var itemRenameContextModal = (0, _react.useDisclosure)();

  var _useState = (0, _react2.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfoCard = _useState2[0],
      setShowInfoCard = _useState2[1];

  var infoCardToggle = function infoCardToggle() {
    return setShowInfoCard(!showInfoCard);
  };

  var _useState3 = (0, _react2.useState)(props.data),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  _react2["default"].useEffect(function () {
    setData(props.data);
  }, [props.data]);

  var updateData = function updateData(newData) {
    setData(newData);
    props.onDataChanged(newData);
  };

  var _useState5 = (0, _react2.useState)(props.rootUUID),
      _useState6 = _slicedToArray(_useState5, 2),
      rootUUID = _useState6[0],
      setRootUUID = _useState6[1];

  var _useState7 = (0, _react2.useState)([{
    index: rootUUID,
    text: data[rootUUID].name
  }]),
      _useState8 = _slicedToArray(_useState7, 2),
      parentNodeHistory = _useState8[0],
      setParentNodeHistory = _useState8[1];

  var _useState9 = (0, _react2.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedFiles = _useState10[0],
      setSelectedFiles = _useState10[1];

  var _useState11 = (0, _react2.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      contextMenu = _useState12[0],
      setContextMenu = _useState12[1];

  var switchParentNode = function switchParentNode(uuid) {
    // find uuid in parentNodeHistory and remove it and all following elements
    var index = parentNodeHistory.findIndex(function (item) {
      return item.index === uuid;
    });

    if (index !== -1) {
      setParentNodeHistory(parentNodeHistory.slice(0, index + 1));
    } else {
      setParentNodeHistory(parentNodeHistory.concat({
        index: uuid,
        text: data[uuid].name
      }));
    }

    setRootUUID(uuid); // add uuid to parentNodeHistory state
  };

  var resolveUUIDFromIndex = function resolveUUIDFromIndex(index) {
    var folder = data[rootUUID];
    return folder.childUUIDs[index] || rootUUID;
  };

  var handleSelectionChange = function handleSelectionChange(ids) {
    setSelectedFiles(ids);
  };

  var handleContextMenu = function handleContextMenu(event, id) {
    setContextMenu({
      id: id,
      spawnX: event.clientX,
      spawnY: event.clientY
    });
  };

  var handleMove = function handleMove(dragUUID, dropUUID) {
    var folder = data[rootUUID]; // Push dragUUID to data[dropUUID].childUUIDs without duplicates

    var droppable = data[dropUUID];

    if (!droppable.childUUIDs.includes(dragUUID)) {
      var _update; // Remove dragUUID from folder.childUUIDs


      var newRootChildUUIDs = folder.childUUIDs.filter(function (uuid) {
        return uuid !== dragUUID;
      });
      var newData = (0, _immutabilityHelper["default"])(data, (_update = {}, _defineProperty(_update, rootUUID, {
        childUUIDs: {
          $set: newRootChildUUIDs
        }
      }), _defineProperty(_update, dropUUID, {
        childUUIDs: {
          $push: [dragUUID]
        }
      }), _update));
      updateData(newData);
      toast({
        title: "Moved item",
        status: 'info',
        isClosable: true,
        position: 'bottom-right'
      });
    }
  };

  var handleListMove = function handleListMove(dragIndex, dropIndex) {
    var dragUUID = resolveUUIDFromIndex(dragIndex);
    var dropUUID = resolveUUIDFromIndex(dropIndex);
    handleMove(dragUUID, dropUUID);
  };

  var handleBreadcrumbMove = function handleBreadcrumbMove(dragIndex, dropUUID) {
    var dragUUID = resolveUUIDFromIndex(dragIndex);
    handleMove(dragUUID, dropUUID);
  };

  var handleUpload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(acceptedFiles, fileRejections) {
      var _iterator, _step, fileRejection, todayDate, files, _iterator2, _step2, _step2$value, i, _file2, name, type, size, kb, mb, sizeString, fileName, src, newData, _i2, _Object$entries, _Object$entries$_i, _uuid2, _file;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              toast.closeAll();

              if (fileRejections.length > 0) {
                _iterator = _createForOfIteratorHelper(fileRejections);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    fileRejection = _step.value;
                    toast({
                      title: "Uploading ".concat(fileRejection.file.name, " rejected"),
                      description: fileRejection.errors.map(function (error) {
                        return error.message;
                      }).join(', '),
                      status: 'error',
                      isClosable: true,
                      position: 'bottom-right'
                    });
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }

              todayDate = new Date().toDateString();
              files = {};
              _iterator2 = _createForOfIteratorHelper(acceptedFiles.entries());
              _context.prev = 5;

              _iterator2.s();

            case 7:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 22;
                break;
              }

              _step2$value = _slicedToArray(_step2.value, 2), i = _step2$value[0], _file2 = _step2$value[1];
              name = _file2.name, type = _file2.type, size = _file2.size; // convert size to kb or mb

              kb = size / 1024;
              mb = kb / 1024;
              sizeString = mb > 1 ? "".concat(mb.toFixed(2), " MB") : "".concat(kb.toFixed(2), " KB"); // check if file is bigger than 2mb if so toast a warning

              if (mb > 1.5) {
                toast({
                  title: "".concat(name, " is a heavy file"),
                  description: "Uploading a file bigger than 2mb might result in performence issues, please consider uploading a smaller file",
                  status: 'warning',
                  isClosable: true,
                  position: 'bottom-right'
                });
              } else {
                toast({
                  title: "Uploading ".concat(name),
                  description: "".concat(sizeString),
                  status: 'info',
                  isClosable: true,
                  position: 'bottom-right'
                });
              }

              fileName = name.split('.')[0];
              _context.next = 17;
              return props.onUploadFile(_file2);

            case 17:
              src = _context.sent;
              files[(0, _uuid3.uuidv4)()] = {
                name: fileName,
                createdAt: todayDate,
                modifiedAt: todayDate,
                src: src,
                mimeType: type,
                size: sizeString
              };
              toast({
                title: "Uploaded ".concat(name, " (").concat(i + 1, "/").concat(acceptedFiles.length, ")"),
                status: 'success',
                isClosable: true,
                position: 'bottom-right'
              });

            case 20:
              _context.next = 7;
              break;

            case 22:
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](5);

              _iterator2.e(_context.t0);

            case 27:
              _context.prev = 27;

              _iterator2.f();

              return _context.finish(27);

            case 30:
              for (_i2 = 0, _Object$entries = Object.entries(files); _i2 < _Object$entries.length; _i2++) {
                _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), _uuid2 = _Object$entries$_i[0], _file = _Object$entries$_i[1];
                newData = (0, _immutabilityHelper["default"])(data, _defineProperty({}, rootUUID, {
                  childUUIDs: {
                    $push: [_uuid2]
                  }
                }));
                newData = (0, _immutabilityHelper["default"])(newData, _defineProperty({}, _uuid2, {
                  $set: _file
                }));
              }

              if (newData) {
                updateData(newData);
              }

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 24, 27, 30]]);
    }));

    return function handleUpload(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleFileInfoBoxUpdate = function handleFileInfoBoxUpdate(details) {
    var uuid = resolveUUIDFromIndex(selectedFiles[0]);
    var todayDate = new Date().toDateString(); // update details of uuid item

    var newData = (0, _immutabilityHelper["default"])(data, _defineProperty({}, uuid, {
      name: {
        $set: details.fileName
      },
      description: {
        $set: details.description
      },
      modifiedAt: {
        $set: todayDate
      }
    }));
    updateData(newData);
  };

  var handleFinishFolderCreate = function handleFinishFolderCreate(name) {
    var todayDate = new Date().toDateString(); // Create new folder

    var uuid = (0, _uuid3.uuidv4)();
    var newData = (0, _immutabilityHelper["default"])(data, _defineProperty({}, rootUUID, {
      childUUIDs: {
        $push: [uuid]
      }
    }));
    newData = _objectSpread(_objectSpread({}, newData), {}, _defineProperty({}, uuid, {
      isFolder: true,
      name: name,
      createdAt: todayDate,
      modifiedAt: todayDate,
      childUUIDs: []
    })); // Update data with new folder

    updateData(newData);
    toast({
      title: "Created folder",
      status: 'success',
      isClosable: true,
      position: 'bottom-right'
    });
    folderCreateContextModal.onClose();
  };

  var handleItemRename = function handleItemRename(name) {
    // Get uuid from selected item
    var uuid = resolveUUIDFromIndex(selectedFiles[0]);
    var todayDate = new Date().toDateString(); // Rename uuid and update modfiedAt

    var newData = (0, _immutabilityHelper["default"])(data, _defineProperty({}, uuid, {
      name: {
        $set: name
      },
      modifiedAt: {
        $set: todayDate
      }
    }));
    updateData(newData);
    itemRenameContextModal.onClose();
  }; //#region > Context Menu handlers


  var handleFileOpen = function handleFileOpen() {
    // get uuid of selected file
    var uuid = resolveUUIDFromIndex(selectedFiles[0]);
    var item = data[uuid];
    setContextMenu(null);

    if (item.isFolder) {
      switchParentNode(uuid);
    } else {
      if (mode === 'selector') {
        if (props.onSelectorSelect) {
          var _fileItem = item; // check if url is valid

          if ((0, _url.isValidHttpUrl)(_fileItem.src)) {
            props.onSelectorSelect(uuid, _fileItem);
          }
        }
      } else {
        props.onItemOpen(uuid);
      }
    }
  };

  var handleFileRename = function handleFileRename() {
    setContextMenu(null);
    itemRenameContextModal.onOpen(); //props.onItemRename(contextMenu.id)
  };

  var handleFileDelete = function handleFileDelete() {
    setContextMenu(null); // Unset uuid from data and update data[rootUUID].childUUIDs

    var uuid = resolveUUIDFromIndex(selectedFiles[0]);
    var newData = (0, _immutabilityHelper["default"])(data, _defineProperty({
      $unset: [uuid]
    }, rootUUID, {
      childUUIDs: function childUUIDs(arr) {
        return arr.filter(function (_uuid) {
          return _uuid !== uuid;
        });
      }
    }));
    setSelectedFiles([]);
    updateData(newData);
  };

  var handleNewFolder = function handleNewFolder() {
    setContextMenu(null);
    folderCreateContextModal.onOpen();
  }; //#endregion


  var prepareFileListItems = function prepareFileListItems() {
    // if parentNode is null tree.nodes is prepared else parentNode.children
    var children = data[rootUUID].childUUIDs.map(function (uuid) {
      return _objectSpread({
        uuid: uuid
      }, data[uuid]);
    });
    return children.map(function (item) {
      var prefix;
      var folderItem = item;
      var fileItem = item;

      if (folderItem.isFolder) {
        prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
          as: _FaFolder.FaFolder,
          w: 6,
          h: 6
        });
      } else {
        var mimeType = fileItem.mimeType,
            src = fileItem.src;

        if (mimeType && mimeType.startsWith('image/')) {
          prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Image, {
            w: 6,
            h: 6,
            src: src
          });
        } else if (mimeType && mimeType.startsWith('application/pdf')) {
          prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            as: _FaFilePdf.FaFilePdf,
            w: 6,
            h: 6
          });
        } else {
          prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            as: _FaFile.FaFile,
            w: 6,
            h: 6
          });
        }
      }

      return {
        prefix: prefix,
        name: item.name,
        modifiedAt: item.modifiedAt,
        fileSize: fileItem.size,
        isFolder: folderItem.isFolder
      };
    });
  };

  var prepareFileInfoBoxProps = function prepareFileInfoBoxProps() {
    var uuid = resolveUUIDFromIndex(selectedFiles[0]);
    var item = data[uuid];
    var folderItem = item;
    var fileItem = item;
    var props = {
      onUpdate: handleFileInfoBoxUpdate,
      details: {
        fileName: item.name,
        fileType: folderItem.isFolder && 'Folder' || _mimeTypes.MimeTypes[fileItem.mimeType],
        fileSize: fileItem.size,
        createdAt: item.createdAt,
        modifiedAt: item.modifiedAt,
        description: item.description
      }
    };

    if (folderItem.isFolder) {
      props['previewElement'] = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
        as: _FaFolder.FaFolder,
        h: 200,
        w: 200
      });
    } else {
      var mimeType = fileItem.mimeType,
          src = fileItem.src,
          previewSrc = fileItem.previewSrc;

      if (mimeType && mimeType.includes('image/')) {
        props['previewImageSrc'] = src;
      } else {
        if (previewSrc) {
          props['previewImageSrc'] = previewSrc;
        } else {
          props['previewElement'] = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            as: _FaFile.FaFile,
            h: 200,
            w: 200
          });
        }
      }
    }

    return props;
  }; // !BUG: useDropzone clashes with react-dnd dropzone inside of FileList component
  // This creates unnecessary re-rendering of this component when FileList dnd is used
  // (occures on drag and drop / click on rows)


  var _useDropzone = (0, _reactDropzone.useDropzone)({
    onDrop: handleUpload,
    maxSize: 5000000
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      isDragAccept = _useDropzone.isDragAccept,
      draggedFiles = _useDropzone.draggedFiles;

  (0, _react2.useEffect)(function () {
    if (isDragActive && isDragAccept) {
      toast({
        title: "Drop to upload ".concat(draggedFiles.length, " file").concat(draggedFiles.length > 1 ? 's' : ''),
        status: 'info',
        isClosable: true,
        position: 'bottom-right'
      });
    }
  }, [isDragActive, isDragAccept, draggedFiles.length]);
  var finderExtras = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [contextMenu && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
        pos: "absolute",
        top: contextMenu.spawnY,
        left: contextMenu.spawnX,
        zIndex: "popover",
        w: "3xs",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileContextMenu["default"], {
          items: contextMenu.id !== undefined ? [{
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: mode === 'selector' ? 'Select' : 'Open'
            }),
            onItemClick: handleFileOpen
          }, {
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: 'Rename'
            }),
            onItemClick: handleFileRename
          }, {
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
              spacing: 2,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DeleteIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Text, {
                children: "Delete"
              })]
            }),
            onItemClick: handleFileDelete
          }] : [{
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: 'New folder'
            }),
            onItemClick: handleNewFolder
          }]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextModal["default"], {
      title: "Create folder",
      inputPlaceholder: "Your new folder",
      finishBtnLabel: "Create",
      onFinish: handleFinishFolderCreate,
      isOpen: folderCreateContextModal.isOpen,
      onClose: folderCreateContextModal.onClose,
      onCancel: folderCreateContextModal.onClose
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextModal["default"], {
      title: "Rename",
      inputPlaceholder: "File name",
      inputText: data[resolveUUIDFromIndex(selectedFiles[0])].name,
      finishBtnLabel: "Rename",
      onFinish: handleItemRename,
      isOpen: itemRenameContextModal.isOpen,
      onClose: itemRenameContextModal.onClose,
      onCancel: itemRenameContextModal.onClose
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Drawer, {
      isOpen: showInfoCard,
      onClose: infoCardToggle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.DrawerContent, {
        minW: "fit-content",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DrawerCloseButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DrawerHeader, {
          children: "File info"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DrawerBody, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileInfoBox["default"], _objectSpread({}, prepareFileInfoBoxProps()))
        })]
      })
    })]
  });

  if (mode === 'selector' && props.onSelectorClose) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [finderExtras, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Modal, {
        isOpen: true,
        onClose: props.onSelectorClose,
        isCentered: true,
        scrollBehavior: "inside",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalOverlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ModalContent, {
          minW: '8xl',
          minH: "85vh",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalHeader, {
            children: "SnekFinder - Selector"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalCloseButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
            px: 4,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar["default"], {
              view: "LIST",
              onViewToggleClick: function onViewToggleClick() {
                return null;
              },
              onInfoToggleClick: infoCardToggle,
              breadcrumbs: parentNodeHistory,
              onBreadcrumbClick: switchParentNode,
              onBreadcrumbDnDMove: handleBreadcrumbMove,
              onUpload: handleUpload,
              onNewFolder: handleNewFolder
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalBody, {
            as: _react.Flex,
            flexDirection: "column",
            pt: 0,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
              flexGrow: 1,
              h: "100vh",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, _objectSpread(_objectSpread({}, getRootProps()), {}, {
                h: '100%',
                _focus: {
                  outline: 'none'
                },
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                onContextMenu: function onContextMenu(e) {
                  e.preventDefault();
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({}, getInputProps())), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileList["default"], {
                  items: prepareFileListItems(),
                  onSelectionDoubleClick: handleFileOpen,
                  onSelectionChange: handleSelectionChange,
                  onContextMenu: handleContextMenu,
                  onDnD: handleListMove,
                  onContextMenuClose: function onContextMenuClose() {
                    return setContextMenu(null);
                  }
                })]
              }))
            })
          })]
        })]
      })]
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [finderExtras, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar["default"], {
      view: "LIST",
      onViewToggleClick: function onViewToggleClick() {
        return null;
      },
      onInfoToggleClick: infoCardToggle,
      breadcrumbs: parentNodeHistory,
      onBreadcrumbClick: switchParentNode,
      onBreadcrumbDnDMove: handleBreadcrumbMove,
      onUpload: handleUpload,
      onNewFolder: handleNewFolder
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, _objectSpread(_objectSpread({}, getRootProps()), {}, {
      h: '90%',
      overflowY: "auto",
      _focus: {
        outline: 'none'
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onContextMenu: function onContextMenu(e) {
        e.preventDefault();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({}, getInputProps())), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileList["default"], {
        items: prepareFileListItems(),
        onSelectionDoubleClick: handleFileOpen,
        onSelectionChange: handleSelectionChange,
        onContextMenu: handleContextMenu,
        onDnD: handleListMove,
        onContextMenuClose: function onContextMenuClose() {
          return setContextMenu(null);
        }
      })]
    }))]
  });
};

var _default = Finder;
exports["default"] = _default;